import { GeolocationArea } from '../../../../domains/Geolocation/Geolocation';
import { Picture } from '../../../../domains/Picture/Picture';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { Continent } from '../../../continent/domain/types/continent';
import { AverageRating } from '../../../rating/domain/types/averageRating';
import { Brand } from '../../../shared/types/brand';

import { OperationalMessage } from './operationalMessage';

export type DestinationId = Brand<number, 'DestinationId'>;

type CommonDestination = {
    id: DestinationId;
    slug: string;
    name: string;
    coverPicture: Picture;
    preposition: string;
    description: string;
    continent: Continent | null;
    geolocation: GeolocationArea;
    alertMessage: string;
    operationalMessages: OperationalMessage[];
    isAvailableForQuoteRequest: boolean;
    hasCommunityContent: boolean;
    averageRating: AverageRating;
    contentUpdatedAt: string | null;
    contentPublishedAt: string | null;
};

export type DestinationTypeCountry = CommonDestination & {
    parentDestination: null;
};

export type DestinationTypeRegion = CommonDestination & {
    parentDestination: DestinationTypeCountry;
};

export type Destination = DestinationTypeCountry | DestinationTypeRegion;

export function isDestinationTypeCountry(
    destination: PickDomain<
        Destination,
        never,
        {
            parentDestination: PickDomain<Destination['parentDestination'], never> | null;
        }
    >,
): destination is DestinationTypeCountry {
    return destination.parentDestination === null;
}
